import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RoleGuardProps {
  requiredPermissions?: string[];
  requiredModule?: string;
  fallback?: string;
}

/**
 * Route access on the same two axes the sidebar uses, so a menu item a user cannot see is also a
 * URL they cannot reach by typing it: the permissions from their login response, and whether
 * their project carries the module at all.
 *
 * Deliberately without a role bypass — a permission the backend did not grant is not one the
 * frontend may assume.
 */
const RoleGuard: React.FC<RoleGuardProps> = ({ requiredPermissions, requiredModule, fallback = '/dashboard' }) => {
  const { hasAnyPermission, isModuleEnabled } = useAuth();

  const passesPermission =
    !requiredPermissions || requiredPermissions.length === 0 || hasAnyPermission(requiredPermissions);

  const passesModule = !requiredModule || isModuleEnabled(requiredModule);

  if (!passesPermission || !passesModule) {
    return <Navigate to={fallback} replace />;
  }

  return <Outlet />;
};

export default RoleGuard;
